import { createColumnHelper } from '@tanstack/react-table';
import { Sample } from '@texas/api/endpoints/samplesApi';
import {
  sampleColumnsCreator,
  SamplesColumnsBaseProps,
} from './sampleColumnsCreator';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';
import { Flex, Heading, Tooltip } from '@chakra-ui/react';
import { UserBadge } from '@texas/components/shared/users/UserBadge';
import { Icons } from '@texas/components/shared/Icons';
import { ShipmentState } from '@texas/api/endpoints/shipmentsApi';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';

export const samplesInTransportColumns = (props: SamplesColumnsBaseProps) => {
  const columnHelper = createColumnHelper<Sample>();
  const columns = [
    columnHelper.accessor('transport.receiverUser.id', {
      cell: (info) => {
        if (!info.row.original.transport) return <></>;
        return (
          <Flex gap={2} alignItems="center">
            <UserBadge
              name={info.row.original.inPossessionOfUser.name}
              userId={info.row.original.inPossessionOfUser.id}
              branch={info.row.original.inPossessionOfUser.branchIdentifier}
            />
            <Icons.ArrowRight />
            <UserBadge
              name={info.row.original.transport.receiverUser.name}
              userId={info.row.original.transport.receiverUser.id}
              branch={info.row.original.transport.receiverUser.branchIdentifier}
            />
            <Tooltip label={props.t('transportRequest.ticket')}>
              <Heading fontSize="lg" fontWeight="normal">
                #{info.row.original.transport.id}
              </Heading>
            </Tooltip>
          </Flex>
        );
      },
      header: '',
    }),
    columnHelper.accessor('transport.requestedDispatchDate', {
      cell: (info) => formatDate(Locale.En, info.getValue()),
      header: props.t('transportRequest.reqDispatchDate'),
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('transport.shipment.dispatchDate', {
      cell: (info) =>
        compareEnum(
          ShipmentState,
          info.row.original.transport?.shipment?.state,
          ShipmentState.Dispatched,
        )
          ? formatDate(Locale.En, info.getValue())
          : null,
      header: 'Dispatched',
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('transport.shipment.courier', {
      cell: (info) =>
        info.row.original.transport?.shipment ? info.getValue() : null,
      header: 'Courier',
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('transport.shipment.trackingNumber', {
      cell: (info) =>
        info.row.original.transport?.shipment ? info.getValue() : null,
      header: 'Tracking number',
      meta: { toggleable: true, defaultVisible: true },
    }),
  ];

  return sampleColumnsCreator({
    t: props.t,
    columns: { afterIndex: 1, columns },
    hideStopFollowing: props.hideStopFollowing,
  });
};
